/* eslint-disable radix */
/* eslint-disable no-restricted-globals */
import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import {
  Dialog,
  useMediaQuery,
  useTheme,
  Fab,
  Box,
  Button,
  Typography,
  CircularProgress,
  InputAdornment,
  TextField,
  IconButton,
} from '@material-ui/core';

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';
import { geocodeByPlaceId, getLatLng } from 'react-places-autocomplete';
import Maps from '../Maps';
import ConfirmAddressCreated from '../ConfirmAddressCreated';
import useStyles from './styles';

function loadScript(src, position, id) {
  if (!position) {
    return;
  }
  const script = document.createElement('script');
  script.setAttribute('async', '');
  script.setAttribute('id', id);
  script.src = src;
  position.appendChild(script);
}

export default function() {
  const classes = useStyles();
  const theme = useTheme();
  const loaded = useRef(false);
  const dispatch = useDispatch();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [createdAddressBasedOnMap, setCreatedAddressBasedOnMap] = useState(
    null
  );
  const [searchAddress, setSearchAddress] = useState('');
  const [mapOpened, setMapOpened] = useState(false);
  const [showButton, setShowButton] = useState(true);
  const [searchFromMap, setSearchFromMap] = useState(false);
  const [searching, setSearching] = useState(false);
  const [options, setOptions] = useState([]);
  const [coordinates, setCoordinates] = useState(null);
  const [currentAddressLocation, setCurrentAddressLocation] = useState(null);
  const [markerCoordinate, setMarkerCoordinates] = useState(null);
  const [addressFromMap, setAddressFromMap] = useState(null);
  const [showError, setShowError] = useState(false);
  const [showButtonAddress, setShowButtonAddress] = useState(false);
  const {
    createAddressBasedOnMap,
    markerCoordinates,
    currentLocation,
  } = useSelector(state => state.adresses);

  if (typeof window !== 'undefined' && !loaded.current) {
    if (!document.querySelector('#google-maps')) {
      loadScript(
        'https://maps.googleapis.com/maps/api/js?key=AIzaSyDnbHQ_2Q9POiAFe6k6D0iW3XiNicNNvdE&libraries=places',
        document.querySelector('head'),
        'google-maps'
      );
    }

    loaded.current = true;
  }

  const handleMap = useCallback(() => {
    setMapOpened(!mapOpened);
  }, [mapOpened]);

  const handleSearchFromMap = useCallback(() => {
    setSearchFromMap(!searchFromMap);
  }, [searchFromMap]);

  const handleCloseSearchMap = useCallback(() => {
    setSearchFromMap(!searchFromMap);
    dispatch({
      type: '@adresses/ADDRESS_CREATED_MAP',
      createdAddressBasedOnMap: null,
    });
  }, [searchFromMap]);

  const handleSearchAddress = useCallback(() => {
    dispatch({ type: '@adresses/SEARCH_ADDRESS' });
  }, []);

  const createAddressWithLocation = useCallback(async () => {
    if (markerCoordinate === null) {
      const location = `${currentLocation.lat},${currentLocation.lng}`;
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${location}&key=AIzaSyDnbHQ_2Q9POiAFe6k6D0iW3XiNicNNvdE`,
        { method: 'GET' }
      );
      const data = await res.json();
      const one = data.results[0] || null;
      setCreatedAddressBasedOnMap({
        name: '',
        zip_code:
          one.address_components[6] === undefined
            ? ''
            : one.address_components[6].long_name,
        public_place: one.address_components[1].long_name,
        number: one.address_components[0].long_name,
        complement: '',
        state: one.address_components[4].short_name,
        code_state: '',
        city: one.address_components[3].short_name,
        code_city: '',
        neighborhood: one.address_components[2].long_name,
        phone: '',
        comments: one.formatted_address,
        latitude: one.geometry.location.lat,
        longitude: one.geometry.location.lng,
      });
      dispatch({ type: '@adresses/CONFIRM_ADDRESS_CREATE' });
    } else if (markerCoordinate !== null) {
      const location = `${markerCoordinate.lat},${markerCoordinate.lng}`;
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${location}&key=AIzaSyDnbHQ_2Q9POiAFe6k6D0iW3XiNicNNvdE`,
        { method: 'GET' }
      );
      const data = await res.json();
      const one = data.results[0] || null;
      setCoordinates(markerCoordinates);
      const address = one.formatted_address.split(/,|-/);
      const firstNumCep = address.length - 3;
      const secondNumCep = address.length - 2;

      setCreatedAddressBasedOnMap({
        name: '',
        zip_code: `${address[firstNumCep]}${address[secondNumCep]}`,
        public_place: one.address_components[1].long_name,
        number: one.address_components[0].long_name,
        complement: '',
        state: one.address_components[4].short_name,
        code_state: '',
        city: one.address_components[3].short_name,
        code_city: '',
        neighborhood: one.address_components[2].long_name,
        phone: '',
        comments: one.formatted_address,
        latitude: markerCoordinate.lat,
        longitude: markerCoordinate.lng,
      });
      dispatch({ type: '@adresses/CONFIRM_ADDRESS_CREATE' });
    }
  }, [markerCoordinate]);

  const createAddress = useCallback(async (place = '') => {
    if (markerCoordinate === null) {
      const results = await geocodeByPlaceId(place);
      const one = results[0] || null;
      const { lat, lng } = await getLatLng(one);
      setCoordinates({ lat, lng });
      setCreatedAddressBasedOnMap({
        name: '',
        zip_code:
          one.address_components[6] === undefined
            ? ''
            : one.address_components[6].long_name,
        public_place: one.address_components[1].long_name,
        number: one.address_components[0].long_name,
        complement: '',
        state: one.address_components[4].short_name,
        code_state: '',
        city: one.address_components[3].short_name,
        code_city: '',
        neighborhood: one.address_components[2].long_name,
        phone: '',
        comments: one.formatted_address,
        latitude: lat,
        longitude: lng,
      });
    }
  }, []);

  const handleCreateAddress = useCallback(async () => {
    dispatch({ type: '@adresses/CONFIRM_ADDRESS_CREATE' });
    await createAddress();
  }, []);

  const filterInt = useCallback(value => {
    if (/^(\-|\+)?([0-9]+|Infinity)$/.test(value)) return true;
    return NaN;
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      setOptions([]);
      setSearching(true);
      setShowButtonAddress(false);
      setShowError(false);
      const formatAddress = searchAddress.split(' ');

      const lengthSearch = formatAddress.length - 1;

      if (filterInt(formatAddress[lengthSearch]) !== true) {
        setShowError(true);
        setSearching(false);
        return;
      }

      if (formatAddress.length < 2) {
        setSearching(false);
        return;
      }

      const formatedAddress = formatAddress.join('+');

      if (formatedAddress.length <= 3) {
        setSearching(false);
        return;
      }

      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${formatedAddress}&region=br&key=AIzaSyDnbHQ_2Q9POiAFe6k6D0iW3XiNicNNvdE`,
        { method: 'GET' }
      );

      const data = await response.json();

      const validOptions = data.results.filter(option => {
        return option.address_components.length >= 7;
      });

      if (validOptions.length === 0) {
        setShowButtonAddress(true);
      }

      setOptions(validOptions);
      setSearching(false);
    }, 2500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchAddress]);

  useEffect(() => {
    dispatch({
      type: '@adresses/ADDRESS_CREATED_MAP',
      createdAddressBasedOnMap,
    });
  }, [createdAddressBasedOnMap]);

  useEffect(() => {
    async function get() {
      const location = `${currentLocation.lat},${currentLocation.lng}`;
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${location}&key=AIzaSyDnbHQ_2Q9POiAFe6k6D0iW3XiNicNNvdE`,
        { method: 'GET' }
      );
      const data = await res.json();
      const one = data.results[0] || null;

      setCurrentAddressLocation({
        name: '',
        zip_code:
          one.address_components[6] === undefined
            ? ''
            : one.address_components[6].long_name,
        public_place: one.address_components[1].short_name,
        number: one.address_components[0].long_name,
        complement: '',
        state: one.address_components[4].short_name,
        code_state: '',
        city: one.address_components[3].short_name,
        code_city: '',
        neighborhood: one.address_components[2].short_name,
        phone: '',
        comments: one.formatted_address,
        latitude: currentLocation.lat,
        longitude: currentLocation.lng,
      });
    }

    if (currentLocation !== null) {
      get();
    }
  }, []);

  useEffect(() => {
    async function get() {
      const location = `${markerCoordinate.lat},${markerCoordinate.lng}`;
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${location}&key=AIzaSyDnbHQ_2Q9POiAFe6k6D0iW3XiNicNNvdE`,
        { method: 'GET' }
      );
      const data = await res.json();
      const one = data.results[0] || null;

      setCreatedAddressBasedOnMap({
        name: '',
        zip_code:
          one.address_components[6] === undefined
            ? ''
            : one.address_components[6].long_name,
        public_place: one.address_components[1].long_name,
        number: one.address_components[0].long_name,
        complement: '',
        state: one.address_components[4].short_name,
        code_state: '',
        city: one.address_components[3].short_name,
        code_city: '',
        neighborhood: one.address_components[2].long_name,
        phone: '',
        comments: one.formatted_address,
        latitude: markerCoordinate.lat,
        longitude: markerCoordinate.lng,
      });

      dispatch({
        type: '@adresses/ADDRESS_CREATED_MAP',
        createdAddressBasedOnMap,
      });
    }

    if (markerCoordinate !== null) {
      get();
    }
  }, [markerCoordinate]);

  const MapsWithAddress = useMemo(
    () => (
      <Maps
        setShowButton={setShowButton}
        coordinates={coordinates}
        setMarkerCoordinates={setMarkerCoordinates}
        setAddressFromMap={setAddressFromMap}
      />
    ),
    [markerCoordinate, coordinates]
  );

  const MapsWithNoAddress = useMemo(
    () => (
      <Maps
        setShowButton={setShowButton}
        setAddressFromMap={setAddressFromMap}
        coordinates={currentLocation}
        setMarkerCoordinates={setMarkerCoordinates}
      />
    ),
    [currentLocation]
  );

  return (
    <div className={classes.root}>
      <TextField
        autoFocus
        fullWidth
        value={searchAddress}
        onChange={event => {
          setSearchAddress(event.target.value);
        }}
        variant="outlined"
        id="input-with-icon-textfield"
        placeholder="Buscar endereço e número"
        InputProps={{
          type: 'search',
          style: {
            background: '#eee',
          },
          startAdornment: (
            <InputAdornment onClick={handleSearchAddress} position="start">
              <ArrowBackIosRoundedIcon className={classes.searchIcon} />
            </InputAdornment>
          ),
        }}
      />
      {showError && (
        <Typography
          style={{
            color: 'red',
            fontSize: 12,
            textAlign: 'center',
            marginTop: 5,
          }}
        >
          É necessário informar também o número do endereço
        </Typography>
      )}

      {options !== undefined && options.length > 0
        ? options.map((option, index) => (
            <Box
            key={index}
            className={classes.searchContainer}
            onClick={() => {
                createAddress(option.place_id);
                setMapOpened(true);
              }}
          >
            <Box className={classes.searchContainerIcon}>
                <LocationOnOutlinedIcon className={classes.icon} />
              </Box>
            <Typography style={{ marginTop: 10, marginBottom: 10 }}>
                {option.formatted_address}
              </Typography>
          </Box>
          ))
        : null}
      {searching && (
        <Box className={classes.content}>
          <CircularProgress className={classes.searchProgress} />
        </Box>
      )}

      {showButtonAddress ? (
        <Box>
          <Typography style={{ marginTop: 20 }}>
            Não achou seu endereço?
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            className={classes.searchFromMapButton}
            onClick={handleSearchFromMap}
          >
            Buscar pelo mapa
          </Button>
        </Box>
      ) : null}

      {options !== undefined && options.length > 0 ? (
        <Box>
          <Typography style={{ marginTop: 20 }}>
            Não achou seu endereço?
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            className={classes.searchFromMapButton}
            onClick={handleSearchFromMap}
          >
            Buscar pelo mapa
          </Button>
        </Box>
      ) : null}
      {mapOpened && (
        <Dialog
          open={mapOpened}
          draggable="false"
          fullScreen={fullScreen}
          maxWidth="xs"
        >
          {MapsWithAddress}
          <Box
            style={{
              position: 'absolute',
              width: '100%',
              height: '60px',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              top: 10,
              left: 0,
            }}
          >
            <IconButton
              onClick={() => {
                handleMap();
                setAddressFromMap(null);
                setCreatedAddressBasedOnMap(null);
              }}
              style={{ color: '#FF9000', marginRight: 10 }}
            >
              <ArrowBackIosIcon />
            </IconButton>
            {addressFromMap === null && createdAddressBasedOnMap !== null && (
              <Box
                style={{
                  display: 'flex',
                  textAlign: 'left',
                  flexDirection: 'column',
                }}
              >
                <Typography style={{ color: '#999', fontWeight: 'bold' }}>
                  {createdAddressBasedOnMap.public_place},{' '}
                  {createdAddressBasedOnMap.number}
                </Typography>
                <Typography style={{ color: '#999' }}>
                  {createdAddressBasedOnMap.neighborhood}
                </Typography>
              </Box>
            )}
            {addressFromMap !== null && (
              <Box
                style={{
                  display: 'flex',
                  textAlign: 'left',
                  flexDirection: 'column',
                }}
              >
                <Typography style={{ color: '#999', fontWeight: 'bold' }}>
                  {addressFromMap.public_place}, {addressFromMap.number}
                </Typography>
                <Typography style={{ color: '#999' }}>
                  {addressFromMap.neighborhood}
                </Typography>
              </Box>
            )}
          </Box>
          {showButton && (
            <div className={classes.field}>
              <Fab
                className={classes.button}
                color="primary"
                onClick={handleCreateAddress}
              >
                confirmar
              </Fab>
            </div>
          )}
        </Dialog>
      )}
      {searchFromMap && (
        <Dialog
          scroll="body"
          draggable="false"
          open={searchFromMap}
          fullScreen={fullScreen}
          maxWidth="xs"
        >
          {MapsWithNoAddress}
          <Box
            style={{
              position: 'absolute',
              width: '100%',
              height: '60px',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              top: 10,
              left: 0,
            }}
          >
            <IconButton
              onClick={() => {
                handleCloseSearchMap();
                setAddressFromMap(null);
              }}
              style={{ color: '#FF9000', marginRight: 10 }}
            >
              <ArrowBackIosIcon />
            </IconButton>
            {addressFromMap === null && (
              <Box
                style={{
                  display: 'flex',
                  textAlign: 'left',
                  flexDirection: 'column',
                }}
              >
                <Typography style={{ color: '#999', fontWeight: 'bold' }}>
                  {currentAddressLocation.public_place},{' '}
                  {currentAddressLocation.number}
                </Typography>
                <Typography style={{ color: '#999' }}>
                  {currentAddressLocation.neighborhood}
                </Typography>
              </Box>
            )}
            {addressFromMap !== null && (
              <Box
                style={{
                  display: 'flex',
                  textAlign: 'left',
                  flexDirection: 'column',
                }}
              >
                <Typography style={{ color: '#999', fontWeight: 'bold' }}>
                  {addressFromMap.public_place}, {addressFromMap.number}
                </Typography>
                <Typography style={{ color: '#999' }}>
                  {addressFromMap.neighborhood}
                </Typography>
              </Box>
            )}
          </Box>
          {showButton && (
            <div className={classes.field}>
              <Fab
                className={classes.button}
                color="primary"
                onClick={createAddressWithLocation}
              >
                confirmar
              </Fab>
            </div>
          )}
        </Dialog>
      )}
      {createAddressBasedOnMap && <ConfirmAddressCreated />}
    </div>
  );
}
